/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TenantPosConfig } from '../../models/tenant-pos-config';
import { TenantPosConfigInput } from '../../models/tenant-pos-config-input';

export interface TenantsTenantIdDefaultConfigsPost$Params {
  tenantId: string;
      body: TenantPosConfigInput
}

export function tenantsTenantIdDefaultConfigsPost(http: HttpClient, rootUrl: string, params: TenantsTenantIdDefaultConfigsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TenantPosConfig>> {
  const rb = new RequestBuilder(rootUrl, tenantsTenantIdDefaultConfigsPost.PATH, 'post');
  if (params) {
    rb.path('tenantId', params.tenantId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TenantPosConfig>;
    })
  );
}

tenantsTenantIdDefaultConfigsPost.PATH = '/tenants/{tenantId}/default-configs';
